module.exports = __webpack_public_path__ + "img/assurancePrevoyance_p2_img1.2848e133.png";